import { schema } from "normalizr";

const modellGruppeSchema = new schema.Entity(
  "modell_gruppe",
  {},
  { idAttribute: "id" }
);

export { modellGruppeSchema };
